import { takeLatest } from 'redux-saga/effects';

import * as ACTION from '../../constants/constants';
import authSaga from './authSaga';
import userSaga from './userSaga';
import courseSaga from './courseSaga';
import profileSaga from './profileSaga';

function* rootSaga() {
  yield takeLatest([
    ACTION.SIGNIN,
    ACTION.SIGNUP,
    ACTION.SIGNOUT,
    ACTION.ON_AUTHSTATE_SUCCESS,
    ACTION.ON_AUTHSTATE_FAIL,
    ACTION.RESEND_VERIFY_EMAIL_CODE,
    ACTION.VERIFY_EMAIL_CODE
  ], authSaga);
  yield takeLatest([
    ACTION.UPGRADE_KYC_TIER_1,
    ACTION.UPGRADE_KYC_TIER_2,
    ACTION.CREDIT_WALLET,
    ACTION.CREATE_CHILD_WALLET
  ], userSaga);
  yield takeLatest([
    ACTION.UPDATE_PROFILE
  ], profileSaga);
  yield takeLatest([
    ACTION.CREATE_COURSE,
    ACTION.UPDATE_COURSE,
    ACTION.DELETE_COURSE,
    ACTION.CREATE_CATEGORY,
    ACTION.DELETE_CATEGORY,
    ACTION.UPDATE_CATEGORY,
    ACTION.CREATE_SECTION,
    ACTION.DELETE_SECTION,
    ACTION.UPDATE_SECTION,
    ACTION.CREATE_LESSON,
    ACTION.DELETE_LESSON,
    ACTION.UPDATE_LESSON
  ], courseSaga);
}

export default rootSaga;
